module.exports = __webpack_public_path__ + "img/director-school-icon5.ae09a0b1.jpg";